// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31XzR","largestCol":"styles_largestCol__1HBaZ","smallestCol":"styles_smallestCol__2vCBz"};